// extracted by mini-css-extract-plugin
export default {"btn":"ThemeSwitch-module__btn--N8Nfs","icon":"ThemeSwitch-module__icon--z67os"};